<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4 v-if="user.role.roleName == 'ADMIN' || user.role.roleName == 'BRANCH_ADMIN'">
              <v-select
                :items="shopList"
                label="Choose Shop..."
                item-text="name"
                item-value="id"
                v-model="queryParams.shopId"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="minQty"
                label="Minimum No"
                v-model="queryParams.minQty"
                type="text"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="maxQty"
                label="Maximum No"
                v-model="queryParams.maxQty"
                type="text"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field name="code" label="Product Code" v-model="queryParams.code" type="text"></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field name="brand" label="Brand Name" v-model="queryParams.brand" type="text"></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="category"
                label="Category Name"
                v-model="queryParams.category"
                type="text"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12>
              <v-card class="font-weight-bold">
                <v-card-title class="blue darken-3">
                  <span class="headline white--text">Summary</span>
                </v-card-title>
                <v-card-text class="font-weight-bold">
                  <div>
                    <span>Total Wholesale qty :</span>
                    <v-chip>
                      <span>{{ totalWholeSaleQty | numFormat}}</span>
                    </v-chip>
                    <v-btn
                      :loading="printAllButtonLoading"
                      color="primary"
                      @click="printAllStockMovementReport('printAllStockMovementReport')"
                    >PRINT ALL</v-btn>
                    <v-btn
                      :loading="exportButtonLoading"
                      color="success"
                      @click="exportAllStockMovementReport()"
                    >EXPORT ALL</v-btn>
                  </div>
                  <div>
                    <span>Total Retail Qty :</span>
                    <v-chip>
                      <span>{{ totalRetailSaleQty }}</span>
                    </v-chip>
                  </div>
                  <div>
                    <span>Total FOC :</span>
                    <v-chip>
                      <span>{{ totalAllFOCQty }}</span>
                    </v-chip>
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 class="mt-1">
              <v-card>
                <v-data-table
                  :headers="headers"
                  :must-sort="true"
                  :items="stockMovementReportList"
                  :loading="showListLoading"
                  :total-items="totalRows"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                >
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td>{{ props.item.productCode }}</td>
                      <td>{{ props.item.productName }}</td>
                      <td>{{ props.item.brand }}</td>
                      <td>{{ props.item.category }}</td>
                      <td>{{ props.item.supplierName }}</td>
                      <td>{{ props.item.shopName }}</td>
                      <td>{{ props.item.wholeSaleQty }}</td>
                      <td>{{ props.item.retailSaleQty }}</td>
                      <td>{{ props.item.totalFOCQty }}</td>
                      <td>{{ props.item.wholeSaleQty+props.item.retailSaleQty+props.item.totalFOCQty }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
            <div
              id="printAllStockMovementReport"
              style="bsale:1px solid black;width:300px;"
              v-show="false"
            >
              <div style="text-align:center">
                <p style="font-size:18px;margin:1px">Stock Movement Report</p>
              </div>
              <div style="text-align:center">
                <p style="font-size:15px;margin:1px">Report Date : [{{ date }}]</p>
              </div>
              <div style="text-align:center">
                <p style="font-size:15px;margin:1px">Total WholeSale Qty : [{{ totalWholeSaleQty }}]</p>
              </div>
              <div style="text-align:center">
                <p
                  style="font-size:15px;margin:1px"
                >Total RetailSale Qty : [{{ totalRetailSaleQty }}]</p>
              </div>
              <div style="text-align:center">
                <p style="font-size:15px;margin:1px">Total FOC Qty : [{{ totalAllFOCQty }}]</p>
              </div>
              <br />
              <div style="padding-left:5px;padding-right:5px">
                <table
                  style="font-family: arial, sans-serif;border-collapse: collapse;
          width: 100%;font-size:11px;border-top:1px solid black"
                >
                  <thead style="border-bottom:1px solid black;border-top:1px solid black">
                    <tr>
                      <th style="text-align:left">Product Code</th>
                      <th style="text-align:left">Product Name</th>
                      <th style="text-align:left">Brand</th>
                      <th style="text-align:left">Category</th>
                      <th style="text-align:left">Supplier</th>
                      <th style="text-align:left">Shop</th>
                      <th style="text-align:left">WholeSale Qty</th>
                      <th style="text-align:left">Retail Qty</th>
                      <th style="text-align:left">FOC Qty</th>
                      <th style="text-align:left">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in allStockMovementReportList" :key="index">
                      <td style="text-align:left">{{item.productCode}}</td>
                      <td style="text-align:left">{{item.productName}}</td>
                      <td style="text-align:left">{{item.brand}}</td>
                      <td style="text-align:left">{{item.category}}</td>
                      <td style="text-align:left">{{item.supplierName}}</td>
                      <td style="text-align:left">{{item.shopName}}</td>
                      <td style="text-align:left">{{item.wholeSaleQty}}</td>
                      <td style="text-align:left">{{item.retailSaleQty}}</td>
                      <td style="text-align:left">{{item.totalFOCQty}}</td>
                      <td
                        style="text-align:left"
                      >{{item.wholeSaleQty + item.retailSaleQty+item.totalFOCQty}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { commonService } from "../../services/common-service";
import { stockMovementService } from "../../services/stock-movement-service";
import { shopService } from "../../services/shop-service";
export default {
  name: "StockMovementList",
  data: () => ({
    date: commonService.formatDate(new Date(), "YYYY-MM-DD"),
    user: JSON.parse(localStorage.getItem("user")),
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true
      },
      {
        text: "Stock Movement Report",
        disabled: true
      }
    ],
    headers: [
      { text: "Product Code", align: "left", sortable: false },
      { text: "Product Name", sortable: false },
      { text: "Brand", sortable: false },
      { text: "Category", sortable: false },
      { text: "Supplier", sortable: false },
      { text: "Shop", sortable: false },
      { text: "WholeSale", sortable: false },
      { text: "Retail", sortable: false },
      { text: "FOC", sortable: false },
      { text: "Total", sortable: false }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      ascending: true,
      page: 1,
      rowsPerPage: 50,
      totalItems: 0
    },
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      shopId: "",
      maxQty: "",
      minQty: "",
      code: "",
      brand: "",
      category: ""
    },
    clonequeryParams: new Object(),
    totalWholeSaleQty: 0,
    totalRetailSaleQty: 0,
    totalAllFOCQty: 0,
    totalRows: 0,
    shopList: [],
    stockMovementReportList: [],
    allStockMovementReportList: [],
    showListLoading: false,
    printAllButtonLoading: false,
    exportButtonLoading: false
  }),
  watch: {
    pagination: {
      handler() {
        this.getStockMovementReportList();
      },
      deep: true
    }
  },

  created() {
    let user = JSON.parse(localStorage.getItem("user"));
    if (user.role.roleName == "ADMIN" || user.role.roleName == "BRANCH_ADMIN") {
      this.getAllShop();
    }
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.maxQty) {
      this.queryParams.maxQty = this.$route.query.maxQty;
    }
    if (this.$route.query.minQty) {
      this.queryParams.minQty = this.$route.query.minQty;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.clonequeryParams = Object.assign({}, this.queryParams);
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "stock-movement-report",
        query: this.queryParams
      });
      this.clonequeryParams = Object.assign({}, this.queryParams);
      this.getStockMovementReportList();
    },
    printAllStockMovementReport(divName) {
      this.printAllButtonLoading = true;
      this.allStockMovementReportList = [];
      stockMovementService
        .allStockMovementReportList(this.clonequeryParams)
        .then(res => {
          if (res.data) {
            this.allStockMovementReportList = res.data.stockMovementList;
            this.totalWholeSaleQty = res.data.totalWholeSaleQty;
            this.totalRetailSaleQty = res.data.totalRetailSaleQty;
            this.totalAllFOCQty = res.data.totalAllFOCQty;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.printAllButtonLoading = false;
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height =500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
        });
    },
    exportAllStockMovementReport() {
      this.exportButtonLoading = true;
      stockMovementService
        .exportAllStockMovementReport(this.clonequeryParams)
        .then(res => {
          commonService.downloadE(res);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.exportButtonLoading = false;
        });
    },
    getAllShop() {
      shopService
        .getAllShop()
        .then(res => {
          this.shopList = res.data;
          this.queryParams.shopId = this.shopList[0].id;
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        })
        .finally(() => {
          this.getStockMovementReportList();
        });
    },

    getStockMovementReportList() {
      this.showListLoading = true;
      stockMovementService
        .stockMovementReportList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage
        )
        .then(res => {
          if (res.data) {
            this.stockMovementReportList = res.data.stockMovementList;
            this.totalRows = res.data.totalElements;
            this.totalWholeSaleQty = res.data.totalWholeSaleQty;
            this.totalRetailSaleQty = res.data.totalRetailSaleQty;
            this.totalAllFOCQty = res.data.totalAllFOCQty;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    }
  }
};
</script>